import "./Header.css";

const Header = () => {
  return (
    <div className="header">
      <a href="/">
        <h1 id="headerTitle">hiragana.se</h1>
      </a>

      <div id="links">
        <a href="/hiragana">
          <h2>hiraganatabell</h2>
        </a>
        <a href="/converter">
          <h2>omvandlare</h2>
        </a>
        <a href="https://www.katakana.se">
          <h2>katakana</h2>
        </a>
      </div>
    </div>
  );
};

export default Header;
